import React from "react";
import {
  Autocomplete as MUIAutoComplete,
  Popper,
  styled,
} from "@mui/material";
import { CustomTextField } from "../formComponents";
import { useAppSelector } from "../../redux";


export const AutoComplete: React.FC<{
  value: any;
  placeholder?: string;
  disabled?: boolean;
  options: { label: string; value: string }[];
  fullWidth?: boolean;
  error?: string;
  onChange?: (value: any) => void;
}> = (props) => {
  const {
    value,
    placeholder,
    options,
    onChange,
    disabled = false,
    fullWidth,
    error = "",
  } = props;

  const customizer = useAppSelector((state) => state.customizer);

  return (
    <MUIAutoComplete
      value={
        value
          ? options.find(
              (x) => x.value.toLowerCase() === value.toLowerCase()
            ) ?? null
          : null
      }
      options={options}
      autoHighlight
      getOptionLabel={(option) => option.label}
      onChange={(e, newValue) => {
        onChange?.(newValue ? newValue.value : null);
      }}
      disabled={disabled}
      sx={{
        width: fullWidth ? "100%" : "auto",
        ".MuiOutlinedInput-root": {
          paddingTop: "2px",
          paddingBottom: "2px",
          fontSize: "0.8rem",
          color: "rgb(38, 38, 38)",
        },
      }}
      slotProps={{
        paper: {
          sx: {
            backgroundColor:
              customizer.activeMode === "dark" ? "#1E1E1E !important" : "#ffffff",
            zIndex: 2000,
          },
        },
      }}
      renderInput={(params) => (
        <CustomTextField
          {...params}
          fullWidth
          placeholder={placeholder}
          disabled={disabled}
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};
